export const NAME_DISCREPANCY_DIVORCE = 'name_discrepancy_divorce';
export const NAME_DISCREPANCY_HMLR_ERROR = 'name_discrepancy_hmlr_error';
export const NAME_DISCREPANCY_MARRIED_OR_PARTNERSHIP = 'name_discrepancy_married_or_partnership';
export const NAME_DISCREPANCY_DEED_POLL = 'name_discrepancy_deed_poll';
export const NAME_DISCREPANCY_PARTNERSHIP_DISSOLVED = 'name_discrepancy_partnership_dissolved';
export const NAME_DISCREPANCY_OTHER = 'name_discrepancy_other';
